import { createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { Transaction, TransactionDetailsState } from 'types/transaction';
import { notify } from 'components/Common/Toast';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';
import { ID } from 'types/common';

const transaction: Transaction = {
    confirmationCode: '',
    type: '',
    amount: 0,
    transactionStatus: '',
    sourceMoneyContainerSubtype: '',
    transactionDateTime: '',
    consumer: {
        firstName: '',
        lastName: '',
        name: '',
        username: '',
        imgUrl: '',
        playerId: null,
        uuid: '',
        blocked: false,
    },
    maxRefundAmount: 0,
    canBeCancelled: true,
    canBeRefunded: false,
    canRequestRefund: true,
};

const initialState: TransactionDetailsState = {
    details: transaction,
    loading: false,
    error: false,
};

export const fetchTransactionDetails = createAsyncThunkWrapper<any, ID>('transactionDetails/fetchTransactionDetails', async (id: ID) => {
    const response: any = await client.get(`/merchant/trxDetail/${id}`);
    return response?.trxHistory;
});
export interface IssueRefundPayload {
    amount: number;
    svaFrom: string;
    currencyCode: string;
    companyCode: string;
    username: string;
}

export interface TransferFundsPayload {
    amount: number;
    companyCode: string;
    containerId: string;
    isM2MTransfer: boolean;
    subject?: string;
    currencyCode: string;
}

export const transferFunds = createAsyncThunkWrapper<any, TransferFundsPayload>(
    'transaction/transferFunds',
    async (trxDetails: TransferFundsPayload) => {
        const response: any = await client.post(`/merchant/paymentM2M`, trxDetails);
        const additionalStatusMessage = response?.contextResponse?.additionalStatusMessage;
        if (response?.code === 200) {
            notify('Funds transferred successfully!', 'success');
        } else if (additionalStatusMessage) {
            notify(additionalStatusMessage, 'error');
        }
        return response;
    }
);

export const issueRefund = createAsyncThunkWrapper<any, IssueRefundPayload>(
    'transactionDetails/issueRefund',
    async (data: IssueRefundPayload) => {
        // removed svaFrom because backend no longer require the svaFrom key
        const { svaFrom, ...rest } = data;
        const response: any = await client.post(`/merchant/transferM2P`, rest);
        if (response?.code === 200) {
            notify('Transaction refunded successfully!', 'success');
        }
        return response;
    }
);

const transactionDetailsSlice = createSlice({
    name: 'parishionerTransactionDetail',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchTransactionDetails.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchTransactionDetails.fulfilled, (state, action) => {
            state.loading = false;
            if (!action.payload) return;
            state.details = action.payload || {};
        });
        builder.addCase(fetchTransactionDetails.rejected, (state) => {
            state.loading = false;
            state.details = initialState.details;
        });
    },
});

export default transactionDetailsSlice.reducer;
